module.exports = __webpack_public_path__ + "assets/good-work.07e9c1ce.svg";